<div class="error-page" class="alert alert-danger" role="alert">
  <p>{{ message }}</p>
</div>